module.exports = __webpack_public_path__ + "static/img/03.b11b8631.png";